const config = {
  /**
   * Api URL
   */
  api_url:
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === "production"
      ? window.location.protocol + "//" + window.location.hostname
      : "http://localhost:8080"),
  endpoints: {
    leads: "leads",
  },
};
export default config;
